import { useId } from 'react';
import Filters from 'src/components/form/filters/filters';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import { SearchFormProps } from 'src/types';
import { EventFilters } from 'src/types/events';
import css from './form.module.scss';

export default function SearchForm({ onSubmit, initialValues }: Readonly<SearchFormProps<Partial<EventFilters>>>) {
  const inputId = useId();

  return (
    <Filters
      initialFilters={initialValues}
      onSearch={onSubmit}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.eventInputGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати подію'
            inputProps={registerAndClearOnChange('search')}
            error={errors?.text?.message}
          />
        </div>
      )}
    />
  );
}
